import isNil from "lodash/isNil";
import { Grid } from "@mui/material";

import { LoadingOrValue } from "@covertree/ui";
import { formatCurrency } from "@covertree/utils";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { PolicyDetailsContentProps } from "../../../types";
import { calculateTotalDue } from "../utils/calculateTotalDue";
import { reduceFees } from "../utils/reduceFees";

export function Financials({ policy, loading }: PolicyDetailsContentProps) {
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        properties={[
          {
            label: "Total Due",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatCurrency(
                  calculateTotalDue(policy?.units[0]?.pricing)
                )}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
          {
            label: "Annual premium",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatCurrency(policy?.units[0].pricing.grossPremium)}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
          {
            label: "Taxes",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatCurrency(policy?.units[0].pricing.grossTaxes ?? 0)}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
          {
            label: "Fees",
            value: (
              <LoadingOrValue
                loading={!policy && loading}
                value={formatCurrency(
                  !isNil(policy?.units[0].pricing.grossFees)
                    ? reduceFees(policy?.units[0]?.pricing)
                    : 0
                )}
                height={24}
                width={121}
              />
            ),
            showAsTypography: true,
            gridSize: 6,
          },
        ]}
      />
    </Grid>
  );
}
